export default "__VITE_ASSET__BZeEy4tg__"